module.exports = __webpack_public_path__ + "4ebf4074f6eb97afd89964bc9b35b441.pdf";